import { AssetTypes as assetTypes } from '../../utils/enums/AssetTypes';
import { getAssetUrl } from '../../utils/getAssetUrl';

export function showAssetInNewWindow(
    asset: { type: assetTypes | string; id: string; externalUrl?: string | undefined | null },
    options?: { objectId?: string | undefined; surveyId?: string | undefined; equipmentId?: string | undefined },
) {
    let assetUrl: string;
    if (asset.externalUrl && asset.externalUrl !== '') {
        assetUrl = asset.externalUrl;
    } else {
        assetUrl = getAssetUrl(asset, { objectId: options?.objectId, surveyId: options?.surveyId, equipmentId: options?.equipmentId });
    }
    window.open(assetUrl, undefined, 'height=600,width=800,status=no,toolbar=no,menubar=yes,location=no');
}
